import React, { useEffect } from "react";

export default function MemberNumberDrawer({ isOpen, onClose }) {
  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="First 1000 Member"
      onClick={onClose}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(0,0,0,0.5)",
        zIndex: 1000,
        display: "flex",
        alignItems: "flex-end",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          width: "100%",
          background: "var(--drawer-bg, #fff)",
          color: "var(--drawer-fg, #111827)",
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          padding: 16,
          boxShadow: "0 -6px 24px rgba(0,0,0,0.12)",
          maxHeight: "80vh",
        }}
      >
        <div
          style={{
            width: 40,
            height: 4,
            borderRadius: 999,
            background: "rgba(107,114,128,0.4)",
            margin: "6px auto 12px",
          }}
        />

        <h3 style={{ fontSize: 18, fontWeight: 800, margin: "0 0 8px" }}>
          First 1000 Member
        </h3>

        <p style={{ fontSize: 14, lineHeight: 1.5, margin: "6px 0 10px" }}>
          This number means you are one of the <strong>first 1000 members</strong> to join BarterFi.
        </p>

        <p style={{ fontSize: 14, lineHeight: 1.5, margin: "6px 0 10px" }}>
          It reflects how early you became part of the community and serves as a
          <strong> permanent appreciation mark</strong> for early supporters of the platform.
        </p>

        <p style={{ fontSize: 14, lineHeight: 1.5, margin: "6px 0 2px" }}>
          Your member number is based on join order on BarterFi and cannot be changed.
        </p>

        <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 12 }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 14px",
              borderRadius: 12,
              border: "1px solid #e5e7eb",
              background: "#f9fafb",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            Got it
          </button>
        </div>
      </div>

      <style>{`
        @media (prefers-color-scheme: dark) {
          :root {
            --drawer-bg: #0f1216;
            --drawer-fg: #e5e7eb;
          }
        }
      `}</style>
    </div>
  );
}
